import React, { useState, useEffect, useContext } from "react";
import { Content, Container } from "../styles";

import NotFound from "../../../../components/notFound/notFound";

import StatusPayment from "../components/StatusPayment";
import TransactionDetails from "../components/TransactionDetail";
import PayerIdentification from "../components/PayerIdentification";
import PurchaseDetail from "../components/PurchaseDetail";

import succesImg from "../../../../assets/images/success.svg";

const Sucesso = (props) => {
  const transaction_response_message = {
    message: props.location.state?.message,
    response: props.location.state?.response_message
  };
  const payer_data = props.location.state?.payer_data;
  const payment_detail = props.location.state?.payment_detail;
  const transaction_detail = props.location.state?.transaction_detail;
  const style_page = props.location.state?.style_page;

  // const transaction_response_message = {
  //   message: "A mensagem virá aqui",
  //   response: "fazendo teste"
  // };

  // const payer_data = {
  //   name: "Thalyson Menezes",
  //   phone: "98981919",
  //   email: "thalyson@menezes.com",
  // };

  // const payment_detail = {
  //   establishment: "44979270000161",
  //   authorization_number: "280129",
  //   emrpay_usn: "230428060724540",
  //   amount: "3000",
  //   installment: "2",
  //   authorizer_id: "41",
  //   payment_type: "C",
  //   payment_date: "29/03/2023T16:31",
  // };

  // const transaction_detail = {
  //   order: "100000992221",
  //   interest_value: "",
  //   product_detail: {
  //     discount: {
  //       type: "amount",
  //       value: 100,
  //     },
  //     items: [
  //       {
  //         product_sku: "SDE000123",
  //         product_type: 5,
  //         product_name: "PS5",
  //         product_description: "Iphone 15, Tela de 6,1 polegadas, cor meia noite,armazenamento 1TB",
  //         description_view: true,
  //         product_price: 400,
  //         quantity: 1,
  //         units: 120,
  //         weight: 400,
  //         expiration_date: "2022-10-31",
  //       },
  //       {
  //         // product_sku: "SDE000123",
  //         product_type: 5,
  //         product_name: "Iphone",
  //         product_description: "Iphone 15, Tela de 6,1 polegadas, cor meia noite,armazenamento 1TB",
  //         description_view: true,
  //         product_price: 188155,
  //         quantity: 6,
  //         units: 120,
  //         weight: 400,
  //         expiration_date: "2022-10-31",
  //       },
  //     ],
  //   },
  //   shipping_detail: {
  //     type: "fixed_amount",
  //     delivery_name: "motoboy",
  //     delivery_price: "4200",
  //     delivery_time: 4
  //   }
  // };

  // const style_page = {
  //   logo: "",
  //   background_color: "#000000"
  // }

  const [stage, setStage] = useState(0);

  const statusData = {
    transactionStatus: {
      image: succesImg,
      title: "Seu pagamento foi aprovado!",
      message: "Informamos que o pagamento associado ao seu pedido foi processado com sucesso.",
    },
    paymentStatus: {
      status: "success",
      message: "Aprovado",
    },
  };

  useEffect(() => {
    setStage(1);

    // Se o state estiver vazio, a página não renderiza
    if (props.location.state) {
      setStage(1);
    } else {
      // Página de não encontrado
      setStage(2);
    }
  }, []);

  return (
    <>
      {stage === 1 && (
        <Content bgColor={style_page.background_color || "#E5E5E5"}>
          <Container id="status-payment">
            <StatusPayment
              transactionStatus={statusData.transactionStatus}
              styledPage={style_page}
              responseMessage={transaction_response_message}
            />
          </Container>

          <Container className="other-containers">
            <TransactionDetails
              paymentStatus={statusData.paymentStatus}
              paymentData={payment_detail}
              orderId={transaction_detail.order || new Date().getTime()}
              reiceptButtonColor={style_page.background_color}
            />
          </Container>

          <Container className="other-containers">
            <PurchaseDetail shippingData={transaction_detail} amount={payment_detail.amount} />
          </Container>

          <Container className="other-containers">
            <PayerIdentification identificationData={payer_data} />
          </Container>
        </Content>
      )}
      {stage === 2 && (
        <>
          <NotFound />
        </>
      )}
    </>
  );
};

export default Sucesso;
